import { normalizeGridGuideSettings } from '@/components/canvas/page/guideSettings';
import type { GridGuideSettings } from '@/components/canvas/document/publicTypes';

export type ComputedGridGuides = {
  horizontal: number[];
  vertical: number[];
};

/** 根据栅格参数计算可吸附/绘制的辅助线坐标（px） */
export function computeGridGuideLines(
  width: number,
  height: number,
  grid: GridGuideSettings | Partial<GridGuideSettings>,
): ComputedGridGuides {
  const { columns, rows, gutter, margin } = normalizeGridGuideSettings(grid);
  const vertical: number[] = [];
  const horizontal: number[] = [];

  const contentW = Math.max(0, width - margin * 2);
  const contentH = Math.max(0, height - margin * 2);

  // 布局：边距 | 列 | 间距 | 列 | … | 边距；n 列 → 2n 条线（每列右缘 + 每个栏间距右缘，不含重复左缘）
  if (columns > 0 && contentW > 0) {
    const colWidth = (contentW - (columns - 1) * gutter) / columns;
    if (colWidth > 0) {
      let x = margin;
      vertical.push(x);
      for (let c = 0; c < columns; c++) {
        x += colWidth;
        vertical.push(x);
        if (c < columns - 1) {
          x += gutter;
          vertical.push(x);
        }
      }
    } else {
      vertical.push(margin, width - margin);
    }
  }

  if (rows > 0 && contentH > 0) {
    const rowHeight = (contentH - (rows - 1) * gutter) / rows;
    if (rowHeight > 0) {
      let y = margin;
      horizontal.push(y);
      for (let r = 0; r < rows; r++) {
        y += rowHeight;
        horizontal.push(y);
        if (r < rows - 1) {
          y += gutter;
          horizontal.push(y);
        }
      }
    } else {
      horizontal.push(margin, height - margin);
    }
  }

  return { horizontal, vertical };
}
